import React from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Tooltip } from "antd";
import { MoonOutlined, SunOutlined } from "@ant-design/icons";

import { toggleTheme } from "hooks/theme";

// View Transitions: o browser fotografa a tela atual e faz um crossfade
// atômico para a nova — nenhum frame de tema misto fica visível, por mais
// lenta que seja a regeneração de estilos do antd. flushSync garante que
// toda a troca (Redux → ConfigProvider → cssinjs) aconteça dentro do
// snapshot. Sem suporte (Firefox antigo), cai no dispatch direto, coberto
// pelo theme-switching do App.js.
export const useThemeSwitch = () => {
    const isDarkMode = useSelector((state) => state.theme.isDarkMode);
    const dispatch = useDispatch();

    const handleToggle = () => {
        if (document.startViewTransition) {
            document.startViewTransition(() => {
                flushSync(() => dispatch(toggleTheme()));
            });
        } else {
            dispatch(toggleTheme());
        }
    };

    return { isDarkMode, handleToggle };
};

const ThemeToggle = () => {
    const { isDarkMode, handleToggle } = useThemeSwitch();

    return (
        <Tooltip title={isDarkMode ? "Mudar para tema claro" : "Mudar para tema escuro"}>
            <Switch
                checked={isDarkMode}
                onChange={handleToggle}
                checkedChildren={<MoonOutlined />}
                unCheckedChildren={<SunOutlined />}
                aria-label="Alternar tema escuro"
            />
        </Tooltip>
    );
};

export default ThemeToggle;
